import { ListPlacementsApiCaller } from '@campaign-manager/core/infra/repo/rmt-api/placement/ListPlacementsApiCaller';
import type { RawPlacementApiResponse } from '@campaign-manager/core/model';

import type RepoCallHookOptions from '../RepoCallHookOptions';
import useGet from '../useGet';

// Singleton caller instance - safe because ApiCaller is stateless
const placementsCaller = new ListPlacementsApiCaller();

export default function usePlacements(opts: RepoCallHookOptions) {
  return useGet<RawPlacementApiResponse[]>(placementsCaller, opts);
}
